"use client";

import { useState } from "react";
import ArrowIcon from "@/components/icons/arrow";
import type { Content } from "@/types/content";

const COLORS = ["#FEF8EB", "#EAFFF7", "#FFF1F1", "#F2FAFE"];

const NEWLINE_RE = /\n+/;

export const ContentSummary = ({ content }: { content: Content }) => {
  const paragraphs =
    content.meta.summary?.split(NEWLINE_RE).filter(Boolean) ?? [];

  const [current, setCurrent] = useState(0);

  if (paragraphs.length === 0) {
    return null;
  }

  if (paragraphs.length === 1) {
    return (
      <div className="rounded-2xl p-4 py-6 my-4 bg-brand-blue-50">
        <h3 className="text-xs font-semibold text-brand-blue-600">
          Makale Özeti
        </h3>
        <p className="text-2xl font-medium">{paragraphs[0]}</p>
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl p-4 py-6 my-4"
      style={{ backgroundColor: COLORS[current] }}
    >
      <h3 className="text-xs font-semibold text-brand-blue-600">
        Makale Özeti
      </h3>
      <p className="text-2xl font-medium min-h-16 transition-opacity duration-300">
        {paragraphs[current]}
      </p>
      <div className="flex items-center justify-between mt-4">
        <div className="flex flex-row">
          <button
            className="cursor-pointer hover:bg-brand-blue-100 size-8 rounded-l-full border border-r-0 border-brand-blue-300 bg-white flex items-center justify-center disabled:opacity-30"
            disabled={current === 0}
            onClick={() => setCurrent((i) => Math.max(0, i - 1))}
            type="button"
          >
            <ArrowIcon className="stroke-neutral-700 rotate-180 size-4" />
          </button>
          <button
            className="cursor-pointer hover:bg-brand-blue-100 size-8 rounded-r-full border border-l-0 border-brand-blue-300 bg-white flex items-center justify-center disabled:opacity-30"
            disabled={current === paragraphs.length - 1}
            onClick={() =>
              setCurrent((i) => Math.min(paragraphs.length - 1, i + 1))
            }
            type="button"
          >
            <ArrowIcon className="stroke-neutral-700 size-4" />
          </button>
        </div>
        <span className="font-medium text-neutral-400">
          {current + 1}/
          <span className="font-semibold">{paragraphs.length}</span>
        </span>
      </div>
    </div>
  );
};
